import React, { useRef } from "react";
import { Stack, Text, Box } from "@chakra-ui/react";
import useFileState from "../../lib/useFileState";
import Dropzone from "./Dropzone";
import DropzonePreview from "./DropzonePreview";
import CameraUploadButton from "./CameraUploadButton";
import type { InputErrorVariant } from "../ui/InputError";

const ArchitectLicenseImageField = ({
  fileState,
  errorVariant = "text",
}: {
  fileState: ReturnType<typeof useFileState>;
  errorVariant?: InputErrorVariant;
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileCapture = (file: File) => {
    fileState.setFile(file);
  };

  const handleCameraClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileInputChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      handleFileCapture(file);
    }
  };

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/png,image/jpeg,application/pdf"
        capture="environment"
        style={{ display: "none" }}
        onChange={handleFileInputChange}
      />
      {fileState.file == null ? (
        <Stack gap={{ base: 5, md: 4 }} width="full">
          <Stack align="center" justify="center" gap={2}>
            <CameraUploadButton onCameraClick={handleCameraClick} />
            <Text fontSize="sm" color="textGray" textAlign="center">
              もしくは
            </Text>
            <Box width="full">
              <Dropzone
                onDrop={(files) => {
                  fileState.setFile(files[0]);
                }}
                name="architect_license_image"
                message={
                  <Box wordBreak={"keep-all"}>
                    構造一級建築士、または設備一級建築士をお持ちの方は、一級建築士の免許証画像を
                    <wbr />
                    アップロードしてください。
                    <br />
                    PNG、JPGもしくはPDFファイルで、5MB未満のサイズでアップロードしてください。
                  </Box>
                }
                error={fileState.error}
                accept={{
                  "image/png": [],
                  "image/jpeg": [],
                  "application/pdf": [],
                }}
                errorVariant={errorVariant}
              />
            </Box>
          </Stack>
        </Stack>
      ) : (
        <DropzonePreview fileState={fileState} />
      )}
    </>
  );
};

export default ArchitectLicenseImageField;
